import { render, staticRenderFns } from "./Authentification.vue?vue&type=template&id=25f60d5c&scoped=true&"
import script from "./Authentification.vue?vue&type=script&lang=js&"
export * from "./Authentification.vue?vue&type=script&lang=js&"
import style0 from "./Authentification.vue?vue&type=style&index=0&id=25f60d5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f60d5c",
  null
  
)

export default component.exports